// export const UPDATE_LIFE_SAVE_PRO_BASIC_PLAN = 'UPDATE_LIFE_SAVE_PRO_BASIC_PLAN'
// export type UpdateLifeSaveProBasicPlan = {
//   type: 'UPDATE_LIFE_SAVE_PRO_BASIC_PLAN',
//   payload: DisplayProduct
// }

// export const updateLifeSaveProBasicPlan = (product: DisplayProduct): UpdateLifeSaveProBasicPlan => ({
//   type: UPDATE_LIFE_SAVE_PRO_BASIC_PLAN,
//   payload: product
// })

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})
